import { type FC } from 'react';

import Button, { ButtonVariant } from '@/components/button';
import RadioGroup from '@/components/radio/radioGroup';
import Typography from '@/components/typography';
import { useInitializeAerialMap } from '@/features/selectionsPanel/exportMenu/aerialMap/useInitializeAerialMap';
import { Orientation } from '@/features/selectionsPanel/exportMenu/aerialMap/utils';

export const AerialMapPanel: FC = () => {
  const {
    captureImageFromBounds,
    selectedOrientation,
    setSelectedOrientation,
    isLoading,
  } = useInitializeAerialMap();

  return (
    <div className="px-4 py-3">
      <Typography variant="h5">Aerial Maps</Typography>

      <Typography className="mt-4" variant="button2">
        Orientation
      </Typography>

      <div className="flex flex-col pt-4">
        <RadioGroup
          additionalProps={{ containerClassName: 'm-0' }}
          options={[
            {
              label: 'Horizontal',
              value: Orientation.LANDSCAPE,
            },
            {
              label: 'Vertical',
              value: Orientation.PORTRAIT,
            },
          ]}
          value={selectedOrientation}
          onChange={(orientation: Orientation) =>
            setSelectedOrientation(orientation)
          }
        />
      </div>

      <Button
        className="mt-6 h-8 w-full"
        isLoading={isLoading}
        variant={ButtonVariant.PRIMARY}
        onClick={captureImageFromBounds}
      >
        <Typography variant="button2">Take Screenshot</Typography>
      </Button>
    </div>
  );
};
